import { Col, Form, Row } from "react-bootstrap";
import FileInput from "../FileInput";
import ColorInput from "../ColorInput";
import ColorPickerAdd from "../ColorPickerAdd";
import ColorPickerClose from "../ColorPickerClose";

const OtherKeys = ({
  formData,
  setFormData,
  onInputChange,
  handleFileChange,
  fileNames,
  files,
  validate,
}) => {
  const otherKeyLabels = {
    space: "Space",
    return: "Return",
    backspace: "Backspace",
    shift: "Shift",
    emoji: "Emoji",
    audio: "Audio",
    numSwitch: "Number Switch",
  };

  const gradientOptions = [
    { value: 1, label: "Top to Bottom" },
    { value: 2, label: "Left to Right" },
    { value: 3, label: "Top Left to Bottom Right" },
    { value: 4, label: "Top Right to Bottom Left" },
  ];

  const addBgColor = (keyName) => {
    setFormData((prev) => ({
      ...prev,
      otherKeys: {
        ...prev.otherKeys,
        [keyName]: {
          ...prev.otherKeys[keyName],
          bgColor: [...prev.otherKeys[keyName].bgColor, "#000000"],
        },
      },
    }));
  };

  const removeBgColor = (keyName, index) => {
    setFormData((prev) => {
      const updatedBgColors = prev.otherKeys[keyName].bgColor.filter(
        (_, i) => i !== index
      );
      return {
        ...prev,
        otherKeys: {
          ...prev.otherKeys,
          [keyName]: {
            ...prev.otherKeys[keyName],
            bgColor: prev.otherKeys[keyName].bgColor.filter(
              (_, i) => i !== index
            ),
            bgOrientation:
              updatedBgColors.length === 1
                ? null
                : prev.otherKeys[keyName].bgOrientation,
          },
        },
      };
    });
  };

  return (
    <>
      {Object.keys(otherKeyLabels).map((keyName) => {
        const keyLabel = otherKeyLabels[keyName];
        const keyData = formData.otherKeys[keyName];
        return (
          <div key={keyName} className="mb-4 p-4 border rounded shadow-sm">
            <h5 className="mb-3 fw-bold">{keyLabel} Key</h5>
            <Row className="g-3">
              <Col md={3}>
                <Form.Group>
                  <Form.Label htmlFor="bgType">Background Type</Form.Label>
                  <Form.Select
                    name={`otherKeys.${keyName}.bgType`}
                    value={keyData.bgType || "color"}
                    onChange={onInputChange}
                    className="my-2"
                  >
                    <option value="color">Color</option>
                    <option value="image">Image</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              {keyData.bgType === "color" && (
                <>
                  <Col md={3}>
                    <div className="d-flex align-items-center gap-4">
                      <Form.Label>Background Color</Form.Label>
                      <ColorPickerAdd
                        addBgColor={addBgColor}
                        keyName={keyName}
                      />
                    </div>
                    <div className="d-flex align-items-center gap-3">
                      {keyData.bgColor.map((color, index) => (
                        <div key={index} className="position-relative">
                          <ColorInput
                            name={`otherKeys.${keyName}.bgColor`}
                            value={color}
                            data-index={index}
                            onChange={onInputChange}
                          />
                          {keyData.bgColor.length > 1 && (
                            <ColorPickerClose
                              removeBgColor={removeBgColor}
                              index={index}
                              keyName={keyName}
                            />
                          )}
                        </div>
                      ))}
                    </div>
                  </Col>
                  {keyData.bgColor.length > 1 && (
                    <Col md={3}>
                      <Form.Group>
                        <Form.Label>Gradient Orientation</Form.Label>
                        <Form.Select
                          name={`otherKeys.${keyName}.bgOrientation`}
                          value={keyData.bgOrientation || ""}
                          onChange={onInputChange}
                          className="my-2"
                          required={keyData.bgColor.length > 1}
                        >
                          <option value="">Select Orientation</option>
                          {gradientOptions.map((orientation) => (
                            <option
                              key={orientation.value}
                              value={orientation.value}
                            >
                              {orientation.label}
                            </option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                  )}
                </>
              )}
              {keyData.bgType === "image" && (
                <>
                  <Col md={3}>
                    <FileInput
                      label="Background Image"
                      name={`otherKeys.${keyName}.bgImage`}
                      data-keyname={keyName}
                      onChange={handleFileChange}
                      required={true}
                      accept="image/*"
                      fileName={fileNames.otherKeys?.[keyName]?.bgImage || ""}
                    />
                  </Col>
                  <Col md={3}>
                    <FileInput
                      label="Background Image for Ipad"
                      name={`otherKeys.${keyName}.ipadBgImage`}
                      data-keyname={keyName}
                      onChange={handleFileChange}
                      required={true}
                      accept="image/*"
                      fileName={fileNames.otherKeys?.[keyName]?.ipadBgImage || ""}
                    />
                  </Col>
                  <Col md={3}>
                    <FileInput
                      label="Background Image (Landscape)"
                      name={`otherKeys.${keyName}.bgImageLandscape`}
                      data-keyname={keyName}
                      onChange={handleFileChange}
                      required={true}
                      accept="image/*"
                      fileName={fileNames.otherKeys?.[keyName]?.bgImageLandscape || ""}
                    />
                  </Col>
                  <Col md={3}>
                    <FileInput
                      label="Background Image for Ipad (Landscape)"
                      name={`otherKeys.${keyName}.ipadBgImageLandscape`}
                      data-keyname={keyName}
                      onChange={handleFileChange}
                      required={true}
                      accept="image/*"
                      fileName={fileNames.otherKeys?.[keyName]?.ipadBgImageLandscape || ""}
                    />
                  </Col>
                </>
              )}
              <Col md={3}>
                <ColorInput
                  label="Border Color"
                  name={`otherKeys.${keyName}.borderColor`}
                  value={keyData.borderColor || "#000000"}
                  onChange={onInputChange}
                />
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Border Width (px)</Form.Label>
                  <Form.Control
                    type="number"
                    name={`otherKeys.${keyName}.borderWidth`}
                    value={keyData.borderWidth || 0}
                    onChange={onInputChange}
                    className="my-2"
                    min={0}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <ColorInput
                  label="Text Color"
                  name={`otherKeys.${keyName}.textColor`}
                  value={keyData.textColor || "#000000"}
                  onChange={onInputChange}
                />
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Corner Radius (px)</Form.Label>
                  <Form.Control
                    type="number"
                    name={`otherKeys.${keyName}.corners`}
                    value={keyData.corners || 0}
                    onChange={onInputChange}
                    className="my-2"
                    min={0}
                  />
                </Form.Group>
              </Col>
              <Col md={3}>
                <Form.Group>
                  <Form.Label>Opacity (Ex., 0.5)</Form.Label>
                  <Form.Control
                    type="number"
                    name={`otherKeys.${keyName}.opacity`}
                    value={keyData.opacity || 0}
                    onChange={onInputChange}
                    className="my-2"
                    min={0}
                    max={1}
                  />
                </Form.Group>
              </Col>
            </Row>
          </div>
        );
      })}
    </>
  );
};

export default OtherKeys;
